export const ConversionInputStreamSourceList = [
  'dialpad',
  'leap-lead',
  'leap-appointment-set',
  'leap-job-created',
  'leap-job-awarded',
  'google-lsa-lead',
] as const;

export type ConversionInputStreamSource =
  (typeof ConversionInputStreamSourceList)[number];
